import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';

import { asyncActions } from '../../../actions/general';
import { loading } from '../../../actions/sessions';
import { confirmStandaloneShoppingCart } from '../../../actions/shopping_carts';
import useSession from '../../../hooks/useSession';
import useSessionEntity from '../../../hooks/useSessionEntity';
import Error from '../../shared/Error';
import ProgressBars from '../../shared/ProgressBars';
import ReturnToMerchant from '../../shared/ReturnToMerchant';
import Support from '../../shared/Support';

export default function StandaloneConfirm() {
  const [, sessionActions] = useSession();
  const dispatch = useDispatch();
  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');
  const [errorFound, setErrorFound] = useState(false);

  useEffect(() => {
    if (cart.status !== 'ordered') {
      dispatch(loading(true));
      dispatch(asyncActions(confirmStandaloneShoppingCart(cart)))
        .then(() => dispatch(loading(false)))
        .then(() => sessionActions.finish());
    } else {
      setErrorFound(true);

      sessionActions.finish();
    }
  }, []);

  if (errorFound) {
    return (
      <div role="main" className="mx-6 sm:mx-auto">
        <div className="my-4 flex items-center">
          <span className="fa-layers fa-fw text-5xl">
            <FontAwesomeIcon
              icon="square"
              className="text-background-error !mx-0"
            />
            <FontAwesomeIcon
              icon={['far', 'triangle-exclamation']}
              className="text-error text-3xl !mx-1.5"
            />
          </span>
          <div className="text-xl sm:text-4xl font-extrabold">We're sorry!</div>
        </div>
        <div className="tracking-wide mb-6 font-light text-lg">
          Something isn't right with your order. Please contact support for
          further guidance.
        </div>
        <Support />
      </div>
    );
  }

  return (
    <div role="main" className="mx-6 sm:mx-auto">
      <ProgressBars />
      <div className="my-4 flex items-center">
        <span className="fa-layers fa-fw text-5xl">
          <FontAwesomeIcon
            icon="square"
            className="text-background-success !mx-0"
          />
          <FontAwesomeIcon
            icon={['far', 'circle-check']}
            className="text-success text-3xl !mx-1.5"
          />
        </span>
        <div className="text-xl sm:text-4xl font-extrabold">
          Congratulations!
        </div>
      </div>

      <Error />

      <div className="font-semibold text-lg tracking-wide mb-6">
        Your order has been processed.
      </div>

      <ReturnToMerchant merchant={merchant} asButton={true} />
    </div>
  );
}
